export const isDevelopment = process.env.NODE_ENV === 'development';
export const hasAdvertising = process.env.REACT_APP_ADVERTISING === 'enabled';
export const idleTimeout = Number(process.env.REACT_APP_IDLE_TIMEOUT_MINS);
export const publicUrl = location.origin + process.env.PUBLIC_URL;
export const hasAdminApproveDeny =
  process.env.REACT_APP_ADMIN_APPROVE_REJECT === 'enabled';
export const hasAdminAppGenerate =
  process.env.REACT_APP_ADMIN_APP_GENERATE === 'enabled';
